import styles from './Skills.module.css';

export const Skills = () => {
    return (
        <div className={styles.container} id="skills">
            <h1 className={styles.heading}>SKILLS</h1>
            <div className={styles.iconsDiv}>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=html" alt="HTML" width="70" height="71" />
                    <div class="skills-card-name">HTML5</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=css" alt="CSS" width="70" height="71" />
                    <div class="skills-card-name">CSS3</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=js" alt="Javascript" width="70" height="71" />
                    <div class="skills-card-name">JAVASCRIPT</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=react" alt="React" width="70" height="71" />
                    <div class="skills-card-name">React js</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=redux" alt="Redux" width="70" height="71" />
                    <div class="skills-card-name">Redux js</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=nodejs" alt="Node" width="70" height="71" />
                    <div class="skills-card-name">Node js</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=expressjs" alt="Express" width="70" height="71" />
                    <div class="skills-card-name">Express js</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=mongodb" alt="Mongo" width="70" height="71" />
                    <div class="skills-card-name">Mongo db</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://pbs.twimg.com/profile_images/1244925541448286208/rzylUjaf_400x400.jpg" alt="Chakra" width="70" height="71" />
                    <div class="skills-card-name">Chakra ui</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=github" alt="Github" width="70" height="71" />
                    <div class="skills-card-name">GITHUB</div>
                </div>
                <div class="skills-card">
                    <img class="skills-card-img" src="https://skillicons.dev/icons?i=git" alt="Git" width="70" height="71" />
                    <div class="skills-card-name">GIT</div>
                </div>
            </div>
        </div>
    );
}